import React, { Component } from 'react';
import { Row, Col, Grid, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { printCode } from '../../../actions/purchaseOrders_actions';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

class PrintBarcodeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
    };
  }

  handleDebouncePrint = _.debounce(() => {
    if (!this.state.weight) {
      alert('Weight cannot be empty!');
      return
    }
    const data = {
      prod_wt: Number(this.state.weight),
      prod_num: this.props.ProductNum,
      pack_time: moment(this.state.date).format('YYYY-MM-DD'),
      prod_ref: this.props.ProductRef,
    }
    this.props.printCode([data]);
  }, 300);

  renderDate = () => {
    return <DateTimePicker
      ref={ref => this.dateInputRef = ref}
      placeholder={'YYYY-MM-DD'}
      format="YYYY-MM-DD"
      className={'test-rw-input'}
      time={false}
      date={true}
      dropUp={false}
      onChange={(date) => {
        this.setState({ date })
      }}
      value={this.state.date}
      defaultValue={undefined}
    />
  }

  renderWt = () => {
    return <div style={{ display: 'flex', flexDirection: 'row', }}>
      <div style={{ fontWeight: 'bold', marginRight: '4px' }}>
        <Translate value='wt' />
      </div>
      <input
        style={{ border: 'solid', borderWidth: '1px', width: '100px', paddingLeft: '4px' }}
        value={this.state.weight}
        onChange={(e) => {
          this.setState({
            weight: e.target.value,
          });
        }}
      />
    </div>
  }

  render() {
    return (
      <Grid style={{ width: 400 }}>
        <Row>
          <Col xs={6}>
            {this.renderDate()}
          </Col>
          <Col xs={6}>
            {this.renderWt()}
          </Col>
        </Row>
        <div style={{ display: 'flex', marginTop: '20px', flexDirection: 'row', justifyContent: 'center', width: '330px' }}>
          <Button className='btn btn-danger'
            onClick={() => {
              this.props.close();
            }}>
            <Translate value='cancel' />
          </Button>
          <Button className='btn btn-primary'
            style={{ marginLeft: '60px' }}
            onClick={this.handleDebouncePrint}>
            <Translate value='print' />
          </Button>
        </div>
      </Grid>
    )
  }
}

const mapDispatchToProps = {
  printCode,
}
export default connect(null, mapDispatchToProps)(PrintBarcodeModal);



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/PrintBarcodeModal.jsx